<template>
<!-- 上传多张图片 -->
  <span>
    <el-upload
      :action="imgUrl"
      :headers="headers"
      list-type="picture-card"
      ref="uploadList"
      :class="uploadClass ? 'upload-list': ''"
      :auto-upload="true"
      :file-list="fileListData"
      :limit="limit"
      :before-upload="onBeforeUploadImage"
      :on-success="uploadSuccess"
      :on-error="uploadError"
    >
      <i slot="default" class="el-icon-plus"></i>
      <div class="upload-test">{{tipsText}}</div>
      <div class="el-upload__tip" slot="tip">{{tips}}</div>
      <div slot="file" slot-scope="{ file }" style="height: 100%;">
        <el-image v-loading="!file.response" class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
        <span v-show="file.response" class="el-upload-list__item-actions">
          <span
            class="el-upload-list__item-preview"
            @click="handlePictureCardPreview(file)"
          >
            <i class="el-icon-zoom-in"></i>
          </span>
          <span
            v-if="!disabled"
            class="el-upload-list__item-delete"
            @click="handleRemove(file)"
          >
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
    </el-upload>
    <!-- 图片预览 -->
    <el-image-viewer
      v-if="dialogVisible"
      :initial-index="initialIndex > -1 ? initialIndex : 0"
      :on-close="()=> {this.dialogVisible = false}"
      :url-list="dialogImageUrl"
    />
  </span>
</template>
<script>
// import upload from '@/utils/upload';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { getItem } from '@/utils/cookie.js'

export default {
  components: { ElImageViewer},
  props: {
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false,
    },
    // 文件上传地址
    imgUrl: {
      type: String,
      default: process.env.VUE_APP_CML_BASE_URL + 'file/image/upload',
    },
    // 允许上传的最大文件个数
    limit: {
      type:Number,
      default: 10
    },
    // 框外提示信息
    tips: {
      type: String,
      default: '只能上传JPG/JPEG/PNG文件，且不超过10张'
    },
    // 框内提示信息
    tipsText: String,
    // 文件最大上传大小
    maxSize: {
      type: Number,
      default: 50
    }
  },
  data: () => ({
    headers: {
      'X-Tenant-Id': 'cml-main-service',
      'X-Session-Id': getItem('sessionId') || localStorage.getItem('sessionId')
    },
    dialogImageUrl: [],
    fileListData: [],
    initialIndex: 0,
    dialogVisible: false,
    uploadClass: false
  }),
  watch: {
    disabled: {
      deep: true,
      immediate: true,
      handler(val) {
        this.uploadClass = val
      }
    }
  },
  mounted() {
  },
  methods: {
    // 设置默认文件列表
    setFileListData(val) {
      this.dialogImageUrl = val
      this.fileListData = val.map(item => {
        return {url: item, response: {data: item}}
      });
      this.uploadClass = this.fileListData.length >= this.limit
    },
    // 检验图片，上传前验证
    onBeforeUploadImage(file) {
      const fileType = file.name.split('.').pop();
      if (['jpg', 'jpeg', 'png', 'JPG', 'JPEG', 'PNG'].indexOf(fileType) === -1) {
        this.$message.error('图片只能是 JPG/JPEG/PNG 格式!');
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < this.maxSize;
      if (!isLt2M) {
        this.$message.error(`上传图片大小不能超过 ${this.maxSize}MB!`);
        return false;
      }
    },
    // 预览图片
    handlePictureCardPreview(file) {
      this.initialIndex = this.fileListData.findIndex(item => item.url === file.url)
      this.dialogVisible = true;
    },
    uploadSuccess(response, file, fileList) {
      if (response.code !== '0') {
        this.$message.error(response.msg)
        return
      }
      this.fileListData = fileList
      this.dialogImageUrl = this.fileListData.map(item => item.response ? item.response.data : item.url)
      this.$emit("img-change", this.dialogImageUrl);
      this.uploadClass = this.fileListData.length >= this.limit
    },
    uploadError() {
      this.$message.error('图片上传失败，请重新上传！')
    },
    // 移除图片
    handleRemove(file) {
      const index = this.fileListData.findIndex(item => item.url === file.url)
      this.fileListData.splice(index,1)
      this.uploadClass = this.fileListData.length >= this.limit
      this.dialogImageUrl = this.fileListData.map(item => item.response ? item.response.data : item.url)
      this.$emit("img-change", this.dialogImageUrl);
    },
  },
};
</script>
<style lang="less">
.el-upload {
  position: relative;
}
.upload-list {
  .el-upload--picture-card {
    display: none;
  }
}
.el-upload-list__item {
  transform: none!important;
}
</style>
<style lang="less" scoped>
.el-upload {
  .upload-test {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    line-height: 25px;
    width: 100%;
    color: #AB0033;
  }
}
</style>
